export default __webpack_public_path__ + "static/media/step2_5.0eaf9707.png";